import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/admin-redux";
import { Button, Form, Loader, Modal } from "semantic-ui-react";

import { Input } from "@neworbit/simpleui-input";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";
import { navigateToParentRoute } from "@teamprevent/common/routing/actions";
import { IsLoadingButton } from "@teamprevent/common/IsLoadingButton";

import { ApplicationState } from "../../../applicationState";
import { taskSelector } from "../../selectors";
import { actionFurtherInformationAndReviewOfFitness } from "../../../healthSurveillance/actions";
import { ACTION_FURTHER_INFORMATION_AND_REVIEW_OF_FITNESS } from "../../../healthSurveillance/actionTypes";

export const ActionFurtherInformationAndReviewOfFitnessModal: React.FunctionComponent = () => {
    const dispatch = useDispatch();

    const [submitted, setSubmitted] = React.useState(false);
    const [taskNotes, setTaskNotes] = React.useState(null);

    const task: TaskModel = useSelector((state: ApplicationState) => taskSelector(state));

    React.useEffect(() => {
        return () => {
            setSubmitted(false);
            setTaskNotes(null);
        };
    }, []);

    const onNotesChanged = (notes: string) => setTaskNotes(notes);

    const onSubmit = () => {
        setSubmitted(true);

        if (taskNotes) {
            dispatch(actionFurtherInformationAndReviewOfFitness(task.customer.id, task.caseId, task.id, taskNotes));
            dispatch(navigateToParentRoute());
        }
    };

    const onClose = () => {
        dispatch(navigateToParentRoute());
    };

    if (!task)
    {
        return <Loader active />;
    }

    return (
        <Modal open>
            <Modal.Header content={task?.description} />
            <Modal.Content>
                <Form loading={!task}>
                    <Input.Textarea readOnly label="Previous Notes" value={task.notes} />
                    <Input.Textarea label="Current Notes" required showErrors={submitted} onChange={onNotesChanged} />
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <IsLoadingButton requestNames={ACTION_FURTHER_INFORMATION_AND_REVIEW_OF_FITNESS} content="Action Task" onClick={onSubmit} />
                <Button content="Cancel" onClick={onClose} />
            </Modal.Actions>
        </Modal>
    );
};
